import { setStorage } from 'utilz';

import * as types from './actions';

export const initialState = {
  user: {}
};

export default function(state = initialState, action) {
  const { type, payload } = action;

  switch (type) {
    case types.SAVE_USER:
      setStorage({
        user: {
          user: { ...state.user, ...payload.user }
        }
      });
      return { ...state, user: { ...state.user, ...payload.user } };
    case types.LOGOUT_USER:
      setStorage({
        user: {
          user: {}
        }
      });
      return { ...state, user: {} };
    case types.DONE_USER:
      setStorage({
        user: {
          user: { ...state.user, registrationDone: true }
        }
      });
      return {
        ...state,
        user: {
          ...state.user,
          registrationDone: true
        }
      };

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/pages/Login/reducer.js